"use client"; 
import Image from "next/image";
import styles from "@/app/styles/offer.module.scss";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { formatEventDate } from '@/app/utils/formatDate';
import CodeDisplay from "@/app/utils/content";

const OfferCarousel = ({ page_banner_sliders }) => {
  return (
    <>
      <Carousel fade className='page-inner-carousel'>
        {page_banner_sliders.map((banner_img, index) => {
            
            let imgurl = "";

            if(banner_img.desktopImage){
            if(banner_img.desktopImage.node){
                if(banner_img.desktopImage.node.mediaItemUrl){
                imgurl = banner_img.desktopImage.node.mediaItemUrl;
                }
            }
            }

            return (
            <Carousel.Item key={index}>
                <Image 
                    
                className={styles.banner_section_main_img}
                src={imgurl}
                width={1920}
                height={1080}
                alt="Banner Image"
                priority
                quality={50}
                />
            </Carousel.Item>
            );
        })}
        </Carousel>
    </>
  );
}
export default OfferCarousel;